<template>
  <v-dialog
    v-model="enableDialog"
    persistent
    width="600"
  >
    <v-card
      v-if="orderId"
      flat
    >
      <v-toolbar
        color="blue"
        dark
        dense
        flat
      >
        <v-toolbar-title class="white--text">
          排出事業者への再申請
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <div class="overline">
              排出事業者
            </div>
            <h4>
              {{ order.name }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="7">
            <div class="overline">
              メールアドレス１
            </div>
            <h4>
              {{ order.email_1 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="5">
            <div class="overline">
              担当名１
            </div>
            <h4>
              {{ order.staff_1 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="7">
            <div class="overline">
              メールアドレス２
            </div>
            <h4>
              {{ order.email_2 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="5">
            <div class="overline">
              担当名２
            </div>
            <h4>
              {{ order.staff_2 }}&nbsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <h4>
              送信するメールアドレスを確認し、修正する場合は排出事業者マスタから行ってください。
            </h4>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
        >
          キャンセル
        </v-btn>
        <v-btn
          color="primary"
          @click="registerButtonClickEvent"
        >
          送信
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SendMailConfirmableDialog',
  components: {},
  mixins: [],
  props: {
    orderId: {
      type: Number,
      default: () => null,
    },
    enableDialog: {
      type: Boolean,
      default: () => false
    },
    afterTransaction: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      order: null,
    }
  },
  computed: {},
  watch: {
    enableDialog (newVal) {
      if (newVal) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverOrderAcceptCollectionSendMailApproval', {
      fetchOrder: 'edit',
    }),
    setVariable () {
      this.fetchOrder({ id: this.orderId }).then((content) => {
        this.order = content
      })
    },
    closeButtonClickEvent () {
      this.$emit('negativeCallback')
    },
    registerButtonClickEvent () {
      this.$emit('positiveCallback', this.afterTransaction)
    },
  }
}
</script>
